<template>
  <vx-card>
    <vs-table pagination :max-items="12" search :data="borrowers">
      <template slot="header" vs-justify="flex-end">
        <div class="flex-1">
          {{ 'รายการทั้งหมด '+ borrowers.length }}
        </div>
        <a :href="`${reportServer}/excel/dashboardStageAging1Borrowers`" target="_blank"><vs-button line-origin="left" color="success">ดาวน์โหลดไฟล์ Excel</vs-button></a>
      </template>
      <template slot="thead">
<!--        <vs-th>ลำดับ</vs-th>-->
        <vs-th>เลขที่บัตรประชาชน</vs-th>
        <vs-th>ชื่อ-นามสกุล</vs-th>
        <vs-th>เลขที่สัญญา</vs-th>
        <vs-th>สถานะการศึกษา (มหาวิทยาลัย)</vs-th>
        <vs-th>วันที่ค้างชำระ</vs-th>
        <vs-th>จำนวนวันค้างชำระ</vs-th>
        <vs-th>ค่าธรรมเนียมคงเหลือ</vs-th>
        <vs-th>เบี้ยปรับคงเหลือ</vs-th>
        <vs-th>ยอดเรียกเก็บค้างชำระ</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(row) in data" :key="row.id">
          <!--          <vs-td class="text-center">-->
          <!--            {{ index  + 1}}-->
          <!--          </vs-td>-->
          <vs-td>
            <router-link :to="{ name: 'customer-borrower-search', params: {id: row.id}}">{{ row.idCardNumber }}</router-link>
          </vs-td>
          <vs-td>
            <router-link :to="{ name: 'customer-borrower-search', params: {id: row.id}}">{{ row.fullName }}</router-link>
          </vs-td>
          <vs-td>
            <router-link :to="{ name: 'accounting-contract-detail', params: {id: row.contractId}}">{{ row.contractNo }}</router-link>
          </vs-td>
          <vs-td>
            {{ row.educationStatusName }}
          </vs-td>
          <vs-td>
            {{ row.agingDate }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.agingNumber }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.accruedFeeRemain | numberFormat }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.accruedPenaltyRemain | numberFormat }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.outstandingAmountRemain | numberFormat }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
const { mapActions: mapDashboardActions, mapState: mapDashboardState } = createNamespacedHelpers('Dashboard');
export default {
  name: 'DashboardStageAging1Borrowers',
  data() {
    return {
      reportServer: process.env.VUE_APP_REPORT_SERVER
    }
  },
  computed: {
    ...mapDashboardState(['dashboardStageAging1Borrowers']),
    borrowers() {
      return this.dashboardStageAging1Borrowers;
    },
  },
  methods: {
    ...mapDashboardActions(['getDashboardStageAging1Borrowers']),
  },
  async created() {
    this.$vs.loading()
    await this.getDashboardStageAging1Borrowers();
    setTimeout(() => {
      this.$vs.loading.close()
    }, 150)
  },
}
</script>

<style scoped>
</style>

